import { getRegions } from './getRegions';
import { IApplicationState } from '../../types/redux';

export function getRegionsForSelect(state: IApplicationState) {
  const regions = getRegions(state);

  return regions.map(region => ({ label: region.name, value: region.id }));
}
